import { validate } from "../../helpers/validate.js";
import { EditorClasses } from "../../styles.js";
import {
  attributesFineprintSchema
} from "./attributes.js";
const scalarFineprint = {
  name: "scalar-fineprint",
  tagName: "scalar-fineprint",
  tiptapName: "scalar-fineprint",
  attributeTransform: () => {
    return validate(attributesFineprintSchema, {});
  },
  render: async () => {
    return `<cite class="${EditorClasses.FinePrint}"><ssg-children></ssg-children></cite>`;
  }
};
export {
  scalarFineprint
};
//# sourceMappingURL=index.js.map
